import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PayoutAccountTypeEnum, PayServiceTypeEnum } from 'app/models';
import { MerchantPaymentMethodModalComponent } from '../merchant-payment-method-modal/merchant-payment-method-modal.component';
import { GetMerchantPayoutAccountResponseDto } from '../../../../../models/lokal/get-payout-account-response';

@Component({
  selector: 'merchant-payment-method-sidebar',
  templateUrl: './merchant-payment-method-sidebar.component.html',
  styleUrls: [
    './merchant-payment-method-sidebar.component.scss',
    '../../merchant-store-onboarding.component.scss',
  ],
})
export class MerchantPaymentMethodSidebarComponent implements OnInit {
  @Input() showPaymentMethodSidebar: boolean = false;
  @Input() payment: GetMerchantPayoutAccountResponseDto = {
    MerchantId: 0,
    UsePaymayaAccount: false,
    PayoutAccountTypeId: PayoutAccountTypeEnum.None,
    AccountName: '',
    AccountNumber: '',
    RejectReason: '',
    PayServiceId: PayServiceTypeEnum.None,
    PayServiceName: ''
  };
  @Output() closePaymentMethodSidebarEmit = new EventEmitter<boolean>();
  @Output() showMerchantPaymentGrid = new EventEmitter<boolean>();

  payoutAccountTypeEnum = PayoutAccountTypeEnum;
  dialog = inject(MatDialog);

  ngOnInit(): void {}

  closeSidebar() {
    this.showPaymentMethodSidebar = false;
    this.closePaymentMethodSidebarEmit.emit(false);
  }

  /** Opens the edit dialog */
  editPaymentMethod() {
    this.closeSidebar();
    const addPaymentDialog = this.dialog.open(MerchantPaymentMethodModalComponent, {
      width: '70%',
      maxWidth: '1000px',
      disableClose: true,
      data: {
        isCreate: false,
        header: 'Update',
        payment: this.payment
      },
    });

    addPaymentDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.showMerchantPaymentGrid.emit(true);
      }
    });
  }
}
